module.exports = "<div class=\"button-wrapper\" [ngClass]=\"{'toggle': type == 'toggle', 'active': active, 'disable': disable, 'hide': hide, 'color-1': color === 0, 'color-2': color === 1, 'color-3': color === 2, 'color-4': color === 3, 'color-0': color === null}\" (click)=\"click()\">\r\n    <div class=\"button-content\" [ngClass]=\"{'small': textSize == 'small'}\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/button/button.component.html
// module id = ./src/app/components/button/button.component.html
// module chunks = main